import { notifications } from './notifications.reducer';

export default {
  notifications
}